export type DEPRECATED_Permission = 'READ_ONLY' | 'CLAIMS_ONLY' | 'ALL';

export const ALL__ACCESS_PERMISSION_TYPE: DEPRECATED_Permission = 'ALL'; // Means requires both 'write' and 'read' access

export const PRIMARY_BUTTON_STYLE: any = {
	backgroundColor: '#275184',
	color: '#FFFFFF',
	margin: '5px',
	whiteSpace: 'nowrap',
};
export const PRIMARY_ICON_BUTTON_STYLE: any = {
	backgroundColor: '#275184',
	color: '#FFFFFF',
	margin: '5px',
	whiteSpace: 'nowrap',
	minWidth: 0,
};
export const DISABLED_BUTTON_STYLE = {
	backgroundColor: 'rgb(2, 69, 122, 0.44)',
	color: '#FFFFFF',
	margin: '5px',
	cursor: 'not-allowed',
};
export const CANCELLATION_COMMENT_MAX_LENGTH = 4096;

export const CUSTOM_ERROR_REGEX = /StartUIerror([\s\S]*?)EndUIerror/g;
export const CUSTOM_ERROR_TAG_REGEX = /StartUIerror|EndUIerror/g;

export const CLONE_ERROR_REGEX =
	/(could not find field)|(no coverage in the current policy)|(must extend the policy end date)/i;
export const PROTECTED_ROUTE_ERROR =
	'This page requires additional permissions to use, please contact your administrator to be assigned.';
export const PROTECTED_ROUTE_ERROR_TITLE = 'Protected Page';
export const PROTECTED_ROUTE_PERMISSIONS_REQUIRED_TITLE =
	'Required Permissions: ';
export const PROTECTED_ROUTE_GO_HOME = 'Go to Home Page';

export const PROTECTED_COMPONENT_ERROR =
	'This page requires additional permissions to use, please contact your administrator to be assigned.';
export const PROTECTED_COMPONENT_ERROR_TITLE = 'Protected Component';
export const PROTECTED_COMPONENT_PERMISSIONS_REQUIRED_TITLE =
	'Required Permissions: ';

export const SESSION_EXPIRED_TITLE = () => 'Session Expired';
export const SESSION_EXPIRED_MESSAGE = () =>
	'Your session has expired. Please log in again.';
export const SESSION_EXPIRED_BUTTON = () => 'Continue';
export const HEADER_HEIGHT = 68;

// Invoice
export const INVOICE_PAGE__AMOUNT_TITLE = 'Amount';
